import React, {Component} from 'react'
import {Slider} from 'antd';
import 'antd/es/slider/style/css'; // 加载 CSS
import PropTypes from 'prop-types'
import {TYPE_COLLEGE, TYPE_UNDERGRADUATE, TAG_MEMBEROF} from '../School/constants'
import './Filter.less'
import {delSessionData, getCategory, getProvince, getScore, getSessionData,getLocalData} from '../../api/school'
import radioDefultImg from '../../assets/radio_default.png';
import radioCheckedImg from '../../assets/radio_checked.png';
class Filters extends Component {
    provinceId=getLocalData('provinceId');
    static propTypes = {
        onFilter: PropTypes.func,
        onHide: PropTypes.func,
    };
    _s_category_id__in=getSessionData('_s_category_id__in');
    _s_memberof=getSessionData('_s_memberof');
    _s_province_id__in=getSessionData('_s_province_id__in');
    _s_tag_211=getSessionData('_s_tag_211');
    _s_tag_double_top=getSessionData('_s_tag_double_top');
    _s_tag_985=getSessionData('_s_tag_985');
    _s_type=getSessionData('_s_type');
    _s_gk_province_id=getSessionData('_s_gk_province_id');
    _s_line_branch=getSessionData('_s_line_branch');
    _s_line_min=getSessionData('_s_line_min');
    _s_line_max=getSessionData('_s_line_max');
    state = {
        totalRankingList:[],
        scoreTypeList:[{id:0,name:'不限'},],
        categories: [],
        provinces: [],
        area: '',
        category: '',
        type: '',
        tag985: false,
        tag211: false,
        tagDoubleTop:false,
        tagMemberof: false,
        filterItems:[],
        checkedList:[],
        levelList:[],
        provinceList:[],
        categoryList:[],
        disabledId:[],
        selectedScoreType:0,
        rankList:[],
        currentRule:this.provinceId==110000?1:this.provinceId==350000?2:2,//1(3+3)北京  2(3+1+2)福建
    };
    componentDidMount() {
        let {currentRule}=this.state;
        let checkedList=[];
        if(this.props.filterItem==='level'){
            this.getLevelList();
            if(this._s_type==10){checkedList.push(10);this.setState({type:10});}
            if(this._s_type==20){checkedList.push(20);this.setState({type:20});}
            if(this._s_tag_211){checkedList.push(211);this.setState({tag211:true});}
            if(this._s_tag_985){checkedList.push(985);this.setState({tag985:true});}
            if(this._s_tag_double_top){checkedList.push(999);this.setState({tagDoubleTop:true});}
        }else if(this.props.filterItem==='province'){
            this.getProvinceList();
            if(this._s_province_id__in){checkedList=this._s_province_id__in.split(',');this.setState({area:this._s_province_id__in});}
        }else if(this.props.filterItem==='category'){
            this.getCategoryList();
            if(this._s_category_id__in){checkedList=this._s_category_id__in.split(',');this.setState({category:this._s_category_id__in});}
        }else if(this.props.filterItem==='score'){
            if(this._s_line_branch&&this._s_line_max&&this._s_line_min){//有历史数据
                this.setState({
                    scoreRange:[this._s_line_min,this._s_line_max],
                    selectedScoreType:this._s_line_branch
                },()=>{
                    this.getScoreList(this._s_line_branch,true)
                })
            }
            else {
                this.setState({selectedScoreType:0},()=>{
                    this.getScoreList(0,false);
                })
            }
        }
        this.setState({checkedList})
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.filterItem==this.props.filterItem){

        }else {
            let {currentRule}=this.state;
            let checkedList=[];
            if(nextProps.filterItem==='level'){
                this.getLevelList();
                if(this._s_type==10){checkedList.push(10);this.setState({type:10});}
                if(this._s_type==20){checkedList.push(20);this.setState({type:20});}
                if(this._s_tag_211){checkedList.push(211);this.setState({tag211:true});}
                if(this._s_tag_985){checkedList.push(985);this.setState({tag985:true});}
                if(this._s_tag_double_top){checkedList.push(999);this.setState({tagDoubleTop:true});}
            }else if(nextProps.filterItem==='province'){
                this.getProvinceList();
                if(this._s_province_id__in){checkedList=this._s_province_id__in.split(',');this.setState({area:this._s_province_id__in});}

            }else if(nextProps.filterItem==='category'){
                this.getCategoryList();
                if(this._s_category_id__in){checkedList=this._s_category_id__in.split(',');this.setState({category:this._s_category_id__in});}
            }
            else if(nextProps.filterItem==='score'){
                if(this._s_line_branch&&this._s_line_branch!=0){
                    this.getScoreList(this._s_line_branch,true);
                    this.setState({
                        scoreRange:[this._s_line_min,this._s_line_max]
                    })
                }
                this.setState({selectedScoreType:currentRule==1?(this._s_line_branch||50):(this._s_line_branch||0)})
            }
            this.setState({checkedList})
        }
    }
    getLevelList(){
        let levelList=[{id:20,name:'本科'},{id:10,name:'专科'},{id:985,name:'985'},{id:211,name:'211'},{id:999,name:'双一流'},];
        this.setState({
            filterItems: levelList,
            levelList,
        })
    }
    getProvinceList(){
        getProvince().then(res => {
            this.setState({
                provinceList:res.data,
                filterItems: res.data,
            })
        })
    }
    getCategoryList(){
        getCategory().then(res => {
            this.setState({
                categoryList: res.data,
                filterItems: res.data,
            })
        })
    }
    getScoreList(branch,hasSessionScore){
        let {scoreTypeList,totalRankingList,selectedScoreType,}=this.state;
        if(scoreTypeList.length<2){
            getScore(this.provinceId).then(res => {
                let repeatBranchList=res.data.map(i=>{return i.branch})
                let branchList=Array.from(new Set(repeatBranchList));
                branchList.map(i=>{
                    if(i==10)scoreTypeList.push({id:10,name:'文科'},)
                    if(i==20)scoreTypeList.push({id:20,name:'理科'},)
                    if(i==30)scoreTypeList.push({id:30,name:'物理组'},)
                    if(i==40)scoreTypeList.push({id:40,name:'历史组'},)
                    if(i==50)scoreTypeList.push({id:50,name:'综合类'},)
                })
                this.setState({
                    scoreTypeList,
                    totalRankingList:res.data,
                })
                if(selectedScoreType!=0){
                    let arr=res.data.filter(i=>i.branch==selectedScoreType);
                    arr.sort((a,b)=>{return a.scoreFrom-b.scoreFrom})
                    let total=arr.length;
                    this.setState({
                        rankList:arr,
                        scoreMax:arr[total-1].scoreFrom,
                        scoreMin:arr[0].scoreFrom,
                    })
                    if(!hasSessionScore){
                        this.setState({
                            scoreRange:[arr[0].scoreFrom,arr[total-1].scoreFrom]
                        })
                    }
                }
            })
        }
        else {
            if(selectedScoreType!=0){
                let arr=totalRankingList.filter(i=>i.branch==selectedScoreType);
                arr.sort((a,b)=>{return a.scoreFrom-b.scoreFrom})
                let total=arr.length;
                this.setState({
                    scoreMax:arr[total-1].scoreFrom,
                    scoreMin:arr[0].scoreFrom,
                    rankList:arr,
                })
                if(!hasSessionScore){
                    this.setState({
                        scoreRange:[arr[0].scoreFrom,arr[total-1].scoreFrom]
                    })
                }
            }
        }

    }
    sliderFormatter=(e)=>{
        let {rankList,currentRule,}=this.state;
        if(currentRule==1){
            if(e<390){
                let rank=rankList.filter(i=>(i.scoreFrom<=e&&i.scoreTo>=e))[0]&&rankList.filter(i=>(i.scoreFrom<=e&&i.scoreTo>=e))[0].ranking;
                return (<div className='tooltip-inner'><p>分数/省排名</p><p>{e}/{rank||0}</p></div>)
            }else {
                let rank=rankList.filter(i=>i.scoreFrom==e)[0]&&rankList.filter(i=>i.scoreFrom==e)[0].ranking;
                return (<div className='tooltip-inner'><p>分数/省排名</p><p>{e}/{rank||0}</p></div>)
            }
        }
        else {
            let rank=rankList.filter(i=>i.scoreFrom==e)[0]&&rankList.filter(i=>i.scoreFrom==e)[0].ranking;
            return (<div className='tooltip-inner'><p>分数/省排名</p><p>{e}/{rank||0}</p></div>)
        }
    }
    handleChangeScore=(id)=>{
        this.setState({selectedScoreType:id},()=>{
            id && id!=0 && (this.getScoreList(id));
        })
    }
    handleFilter() {
        const {
            area,
            category,
            type,
            tag985,
            tag211,
            tagMemberof,
            tagDoubleTop,
            selectedScoreType,
            scoreRange,
            currentRule,
        } = this.state;
        let filter={
            _s_tag_985: tag985 || this._s_tag_985,
            _s_tag_211: tag211 || this._s_tag_211,
            _s_memberof: tagMemberof ? TAG_MEMBEROF : this._s_memberof,
            _s_type: type || this._s_type ,
            _s_tag_double_top:tagDoubleTop ||this._s_tag_double_top,
            _s_category_id__in: category ||this._s_category_id__in,
            _s_province_id__in: area ||this._s_province_id__in,
            _s_line_branch:selectedScoreType||this._s_line_branch,
        };

        if(selectedScoreType!=0){
            filter._s_gk_province_id=this.provinceId;
            filter._s_line_min=scoreRange[0]||this._s_line_min;
            filter._s_line_max=scoreRange[1]||this._s_line_max;
        }
        // if(this.props.filterItem ==='level'){
        //     filter = {
        //         _s_tag_985: tag985 || null,
        //         _s_tag_211: tag211 || null,
        //         _s_memberof: tagMemberof ? TAG_MEMBEROF : null,
        //         _s_type: type || null,
        //         _s_tag_double_top:tagDoubleTop ||null,
        //         _s_category_id__in: this._s_category_id__in ||null,
        //         _s_province_id__in: this._s_province_id__in ||null,
        //         _s_line_branch:this._s_line_branch||0,
        //     };
        //     if(this._s_line_branch!=0){
        //         filter._s_gk_province_id=this._s_gk_province_id;
        //         filter._s_line_min=this._s_line_min;
        //         filter._s_line_max=this._s_line_max;
        //     }
        // }
        // else if(this.props.filterItem ==='province'){
        //     filter = {
        //         _s_province_id__in: area || null,
        //         _s_category_id__in: this._s_category_id__in ||null,
        //         _s_tag_985: this._s_tag_985 ||null,
        //         _s_tag_211: this._s_tag_211 ||null,
        //         _s_memberof: this._s_memberof ||null,
        //         _s_type: this._s_type ||null,
        //         _s_tag_double_top:this._s_tag_double_top ||null,
        //         _s_line_branch:this._s_line_branch||0,
        //     };
        //     if(this._s_line_branch!=0){
        //         filter._s_gk_province_id=this._s_gk_province_id;
        //         filter._s_line_min=this._s_line_min;
        //         filter._s_line_max=this._s_line_max;
        //     }
        // }
        // else if(this.props.filterItem ==='category'){
        //     filter = {
        //         _s_category_id__in: category || null,
        //         _s_province_id__in: this._s_province_id__in ||null,
        //         _s_tag_985: this._s_tag_985 ||null,
        //         _s_tag_211: this._s_tag_211 ||null,
        //         _s_memberof: this._s_memberof ||null,
        //         _s_type: this._s_type ||null,
        //         _s_tag_double_top:this._s_tag_double_top ||null,
        //         _s_line_branch:this._s_line_branch||0,
        //     };
        //     if(this._s_line_branch!=0){
        //         filter._s_gk_province_id=this._s_gk_province_id;
        //         filter._s_line_min=this._s_line_min;
        //         filter._s_line_max=this._s_line_max;
        //     }
        // }
        // else if(this.props.filterItem ==='score'){
        //     filter = {
        //         _s_category_id__in: this._s_category_id__in || null,
        //         _s_province_id__in: this._s_province_id__in ||null,
        //         _s_tag_985: this._s_tag_985 ||null,
        //         _s_tag_211: this._s_tag_211 ||null,
        //         _s_memberof: this._s_memberof ||null,
        //         _s_type: this._s_type ||null,
        //         _s_tag_double_top:this._s_tag_double_top ||null,
        //         _s_line_branch:selectedScoreType||0,
        //     };
        //     if(selectedScoreType!=0){
        //         filter._s_gk_province_id=350000;
        //         filter._s_line_min=scoreRange[0];
        //         filter._s_line_max=scoreRange[1];
        //     }
        // }
        this.props.onFilter(filter);
    }
    handleResetFilter() {
        let {currentRule} =this.state;
        this.setState({
            area: '',
            category: '',
            type: '',
            tag985: false,
            tag211: false,
            tagMemberof: false,
            tagDoubleTop:false,
            checkedList:[],
            selectedScoreType:0,
        });
        delSessionData('_s_province_id__in');
        delSessionData('_s_category_id__in');
        delSessionData('_s_tag_985');
        delSessionData('_s_tag_211');
        delSessionData('_s_memberof');
        delSessionData('_s_type');
        delSessionData('_s_tag_double_top');
        delSessionData('_s_line_branch');
        delSessionData('_s_gk_province_id');
        delSessionData('_s_line_min');
        delSessionData('_s_line_max');
        this._s_category_id__in=null;
        this._s_memberof=null;
        this._s_province_id__in=null;
        this._s_tag_211=null;
        this._s_tag_double_top=null;
        this._s_tag_985=null;
        this._s_type=null;
        this._s_gk_province_id=null;
        this._s_line_branch=null;
        this._s_line_min=null;
        this._s_line_max=null;
    }
    handleHideFilter() {
        this.props.onHide()
    }
    checkedItem(e,id){
        e.stopPropagation();
        let {checkedList}=this.state;
        if(checkedList.indexOf(id)>-1||checkedList.indexOf(id+'')>-1) {
            checkedList.splice(checkedList.indexOf(id), 1)
        }else {
            checkedList.push(id);
        }
        if(this.props.filterItem==='level'){
            if(checkedList.includes(10)||checkedList.includes('10')){this.setState({type:10,tag985:false,tag211:false,tagDoubleTop:false})}
            if(checkedList.includes(20)||checkedList.includes('20')){this.setState({type:20})}
            if(checkedList.includes(985)||checkedList.includes('985')){this.setState({tag985:true,type:20})}
            if(checkedList.includes(211)||checkedList.includes('211')){this.setState({tag211:true,type:20})}
            if(checkedList.includes(999)||checkedList.includes('999')){this.setState({tagDoubleTop:true,type:20})}
        }else if(this.props.filterItem==='province'){
            let area=checkedList.join();
            this.setState({area})
        }else if(this.props.filterItem==='category'){
            let category=checkedList.join();
            this.setState({category})
        }
        this.setState({checkedList})
    }
    dealLevel=(currentId)=>{
        const {checkedList,} = this.state;
        return ((checkedList.indexOf(10)>-1||checkedList.indexOf('10')>-1)&&this.props.filterItem=='level'&&([985,211,999,20].includes(currentId)))
            ||
            ((checkedList.indexOf(20)>-1||checkedList.indexOf('20')>-1)&&this.props.filterItem=='level'&&([10].includes(currentId)))
            ||
            ((checkedList.indexOf(985)>-1||checkedList.indexOf('985')>-1)&&this.props.filterItem=='level'&&([10].includes(currentId)))
            ||
            ((checkedList.indexOf(211)>-1||checkedList.indexOf('211')>-1)&&this.props.filterItem=='level'&&([10].includes(currentId)))
            ||
            ((checkedList.indexOf(999)>-1||checkedList.indexOf('999')>-1)&&this.props.filterItem=='level'&&([10].includes(currentId)))
    };
    render() {
        const {
            filterItems,
            checkedList,
            selectedScoreType,
            rankList,
            currentRule,
            scoreTypeList,
        } = this.state;
        return (
            <div className="filter-pop" onClick={(e)=>{e.stopPropagation()}}>
                {this.props.filterItem==='score'?
                    <div className='filter-items-score'>
                        {/*{currentRule!=1&&*/}
                            <div className="top">
                                <span>分数范围：</span>
                                {scoreTypeList.map((i,index)=>{
                                    return <span key={index} className={`${selectedScoreType==i.id?'bold-remind':''}`} onClick={()=>this.handleChangeScore(i.id)}><img src={selectedScoreType==i.id?radioCheckedImg:radioDefultImg} alt=""/>{i.name}</span>
                                })}
                            </div>
                        {/*}*/}
                        {selectedScoreType!=0&&rankList.length>0&&
                            <div className="bottom" id='slider-containers'>
                                <Slider range value={this.state.scoreRange} max={this.state.scoreMax} min={this.state.scoreMin} tooltipVisible  tooltipPlacement='top' tipFormatter={(e)=>this.sliderFormatter(e)} onChange={(e)=>{this.setState({scoreRange:e})}} getTooltipPopupContainer={()=>document.getElementById('slider-containers')}/>
                                <span className='legend'>拖动圆点选择「分数/省排名」范围</span>
                            </div>
                        }
                    </div>
                    :
                    <div className='filter-items'>
                        {filterItems.map((i,index)=>{
                            return <div className='equipartition' key={index}
                                        style={{color:this.dealLevel(i.id)?'#ccc':'#4a4a4a'}}
                                        onClick={e=>{this.dealLevel(i.id)?console.log('禁选'):this.checkedItem(e,i.id)}}
                            >
                                <input
                                    type="checkbox"
                                    id={i.id}
                                    checked={checkedList.indexOf(i.id)>-1||checkedList.indexOf(i.id+'')>-1}
                                    disabled={this.dealLevel(i.id)&&true}
                                />
                                <span >{i.name}</span>
                            </div>
                        })}
                    </div>
                }
                <p className="btn-wrapper">
                    <button className="" onClick={this.handleResetFilter.bind(this)}>重置筛选</button>
                    <button className="primary" onClick={this.handleFilter.bind(this)}>确定</button>
                </p>
            </div>
        )
    }
}

Filters.defaultProps = {};

export default Filters



// WEBPACK FOOTER //
// ./src/pages/SchoolWishListNew/Filters.js